

import React from 'react';
import ZProps from './zprops';
import ZUtil from './zutil';
import AMC from './AMC';
import AMCConstants from './AMCConstants';
import ROUTER from './AMCRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class ZooGenericTrackedButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		this.listener = ZProps.addListener(AMCConstants.TRACKINGS_LOADED, (name, value, oldvalue) => {
			this.forceUpdate();
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
	}
	onClick(e) {
		let { link, track_clicks, tracking_uri, onClick } = this.props;
		e.preventDefault();
		if (ZProps.get("beta")) {
			AMC.track(tracking_uri);
			this.setState({ label_override: "Beta requires sign in first" });
			return false;
		}
		if (track_clicks) {
			// otherwise track at destination
			AMC.track(tracking_uri);
		}
		if (link) {
			ROUTER.pushRoute(link);
		} else if (onClick) {
			onClick(e);
		}
		return false;
	}
	render() {
		let { link, label, icon, tracking_uri } = this.props;
		let { label_override } = this.state;
		return (
			<a className="HScoreButton" onClick={this.onClick.bind(this)} href={link}>
			<div className="HScoreButtonLabel" aria-label="Do this thing">
				{ icon ? <FontAwesomeIcon icon={icon} /> : '' }
				{label_override || label}
			</div>
			<div className="HScoreButtonCount">{ZUtil.toShortCount(ZProps.get(tracking_uri) || 0)}</div>
			</a>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooGenericTrackedButton.js